export const getData = async (endpoint, user, setData, setError, setIsLoading) => {
  setIsLoading(true);
  try {
    const response = await fetch(endpoint, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': user.credential
        },
        method: 'GET'
    });
    if (!response.ok) {
      response.text().then(message => setError(message));
      return
    }
    const jsonData = await response.json();
    setData(jsonData);
  } catch (err) {
    setError(err);
  } finally {
    setIsLoading(false);
  }
};

export const postData = (endpoint, user, requestBody, setData, setError, setIsLoading) => {
  setIsLoading(true);
  try {
    fetch(endpoint, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': user.credential
        },
        method: 'POST',
        body: JSON.stringify(requestBody)
    })
    .then(response => {
      // console.log(response)
      if (!response.ok) {
        response.text().then(message => {
          if (message) {
            if (typeof message === 'string' && (message.startsWith('{') || message.startsWith('['))) {
              setError(JSON.parse(message));
              return;
            }
            setError(message);
          }
        });
        return
      }
      response.text().then(r => {
        if (r) {
          if (typeof r === 'string' && (r.startsWith('{') || r.startsWith('['))) {
            setData(JSON.parse(r));
            return;
          }
          setData(r);
        }
      });
    })
  } catch (err) {
    setError(err);
  } finally {
    setIsLoading(false);
  }
};